export function addParams(url: string, params: any): string {
    if (!params) {
        return url;
    }
    let strParams = Object.keys(params)
        .map((key) => encodeParam(key, params[key]))
        .filter((x) => x != null);
    return url + '?' + strParams.join('&');
}

function encodeParam(key: string, value: string) {
    if (!key || value === null) {
        return null;
    }
    return encodeURIComponent(key) + '=' + encodeURIComponent(value);
}
